import { render, staticRenderFns } from "./how-to.vue?vue&type=template&id=2062abd1&scoped=true&lang=pug&"
import script from "./how-to.vue?vue&type=script&lang=js&"
export * from "./how-to.vue?vue&type=script&lang=js&"
import style0 from "./how-to.vue?vue&type=style&index=0&id=2062abd1&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2062abd1",
  null
  
)

/* custom blocks */
import block0 from "~/lang/howTo?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Fhome%2Fubuntu%2Fnuxt%2Fbonkers%2Freleases%2F20230530095517%2Fcomponents%2Fproducts%2Fhow-to.vue"
if (typeof block0 === 'function') block0(component)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {ProductsProviderList: require('/home/ubuntu/nuxt/bonkers/releases/20230530095517/components/products/provider-list.vue').default})
